import React, { useEffect, useRef, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import ArrowOutward from "@mui/icons-material/ArrowOutward";
import Menu from "@mui/icons-material/Menu";
import Close from "@mui/icons-material/Close";
import BrandLockup from "./BrandMark";
import "../styles/brand.css";

const links = [
  ["/about", "About"],
  ["/workspace", "Workspace"],
  ["/api", "Workers API"],
  ["/vision", "Vision"],
  ["/manifesto", "Manifesto"],
  ["/careers", "Careers"],
];

export default function Navigation() {
  const [open, setOpen] = useState(false);
  const toggle = useRef(null);
  const drawer = useRef(null);
  const location = useLocation();
  useEffect(() => setOpen(false), [location.pathname, location.hash]);
  useEffect(() => {
    if (!open) return undefined;
    const previous = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const onKey = (event) => {
      if (event.key === "Escape") {
        setOpen(false);
        toggle.current.focus();
      }
      if (event.key === "Tab") {
        const nodes = [
          toggle.current,
          ...drawer.current.querySelectorAll("a, button"),
        ].filter(Boolean);
        if (event.shiftKey && document.activeElement === nodes[0]) {
          event.preventDefault();
          nodes[nodes.length - 1].focus();
        }
        if (
          !event.shiftKey &&
          document.activeElement === nodes[nodes.length - 1]
        ) {
          event.preventDefault();
          nodes[0].focus();
        }
      }
    };
    const onResize = () => {
      if (window.innerWidth > 1000) setOpen(false);
    };
    document.addEventListener("keydown", onKey);
    window.addEventListener("resize", onResize);
    drawer.current.querySelector("a")?.focus();
    return () => {
      document.body.style.overflow = previous;
      document.removeEventListener("keydown", onKey);
      window.removeEventListener("resize", onResize);
    };
  }, [open]);
  return (
    <header className="brand-header">
      <a className="brand-skip" href="#main-content">
        Skip to content
      </a>
      <nav className="brand-nav" aria-label="Main navigation">
        <Link
          className="brand-home"
          to="/"
          aria-label="GrupaAI home"
          onClick={() => setOpen(false)}
        >
          <BrandLockup />
        </Link>
        <div className="brand-nav-links">
          {links.map(([to, label]) => (
            <NavLink key={to} to={to}>
              {label}
            </NavLink>
          ))}
        </div>
        <div className="brand-nav-actions">
          <Link to="/desktop#downloads" className="brand-nav-cta">
            Get Momentum <ArrowOutward fontSize="inherit" />
          </Link>
        </div>
        <button
          className="brand-menu-toggle"
          ref={toggle}
          onClick={() => setOpen(!open)}
          aria-label={open ? "Close navigation" : "Open navigation"}
          aria-expanded={open}
          aria-controls="brand-mobile-menu"
        >
          {open ? <Close /> : <Menu />}
        </button>
      </nav>
      {open && (
        <div ref={drawer} id="brand-mobile-menu" className="brand-mobile-menu">
          <span className="brand-eyebrow">Explore GrupaAI</span>
          {links.map(([to, label], i) => (
            <NavLink key={to} to={to}>
              <span className="brand-menu-index">0{i + 1}</span>
              {label}
              <ArrowOutward />
            </NavLink>
          ))}
          <div className="brand-mobile-bottom">
            <Link to="/blog">Journal</Link>
            <Link to="/innovators">Innovators</Link>
            <a
              href="https://discord.gg/dDTem2P"
              target="_blank"
              rel="noreferrer"
            >
              Discord <ArrowOutward fontSize="inherit" />
            </a>
          </div>
          <Link to="/desktop#downloads" className="brand-button">
            Get Momentum <ArrowOutward />
          </Link>
        </div>
      )}
    </header>
  );
}
